<div>
    <div class="card">
        <div class="card-header">
           Gestión de usuarios
        </div>
    </div>



      <div >
        <table datatable [dtOptions]="dtOptions"[dtTrigger]="dtTrigger" class="row-border hover" id="tabla"   >
          <thead>
            <tr>
              <th>Acciones</th>
              <th>nombre</th>
              <th>email</th>
              <th>empresa</th>
            </tr>
          </thead>
          <tbody>
             
      
            <tr *ngFor="let item of arraydeposts">
              <td><button type="button" class="btn btn-primary btn-sm" (click)="detallesUsuario(item)"> Acciones</button></td>
              <td><small>{{item.data().nombre}}</small></td>
              <td><small>{{item.data().email}}</small></td>
              <td><small>{{item.data().empresa}}</small></td>
            </tr>
            
          </tbody>
        </table>
      </div>



</div>
